<body>
  <div>
    <table class="table2" *ngIf="usuarioLogado">
      <thead>
        <div class="align-left search">
          <!-- <input type="date" [(ngModel)]="filtraData" class="modal-input1" />
        <button class="modal-button" type="button" (click)="filtraPelaData()">Filtrar</button> -->
          <div class="filter">
            <div>
              <label for="search">Filter</label>
              <input type="text" name="search" [(ngModel)]="searchString" (keyup)="aplicarFiltro()"
                placeholder="Filter">
            </div>
            <div *ngIf="usuarioLogado.role == '9'">
              <label for="novaData">Outros periodos</label>
              <input type="date" #dateInput2 name="novaData" [(ngModel)]="dateFilter" placeholder="Insira a data">
              <button class="modal-button" type="button" (click)="buscaOutroDia()">Atualizar</button>
              <button class="modal-button" type="button" (click)="reinicia()">Limpa Filtro</button>
            </div>
          </div>
          <div class="iconePlus">
            <i-feather name="plus-circle" (click)="editDialog('')"></i-feather>
            <span class="viagem">Adicionar Viagem</span>
          </div>
          <div class="iconePlus" *ngIf="usuarioLogado.role == '9'">
            <i-feather name="aperture" (click)="acertaModelo()"></i-feather>
            <span class="viagem">Acerta modelo</span>
          </div>
          <th class="corlinha">
            Interplantas
          </th>
        </div>
      </thead>
    </table>

    <div>
      <div class="table2">
        <table>

          <thead>
            <tr>
              <th class="auto-width">
                Transportadora
              </th>
              <th class="auto-width">
                Tipo de Veículo
              </th>
              <th class="auto-width">
                Placa Cavalo
              </th>
              <th class="auto-width">
                Placa Carreta
              </th>
              <th class="auto-width">
                Localização Atual do Veículo
              </th>
              <th class="auto-width">
                Rastreio
              </th>
              <th class="auto-width">
                <button (click)="sortByRota('rota')">Rota</button>
              </th>
              <th class="auto-width">
                Chegou
              </th>
              <th class="auto-width">
                <button (click)="sortBy('viagem')">Viagem</button>
              </th>
              <th class="auto-width">
                Local
              </th>
              <th class="auto-width">
                Janela
              </th>
              <th class="auto-width">
                Observação
              </th>
              <!-- <th class="auto-width">
                Janela 2
              </th>
              <th class="auto-width">
                Janela 3
              </th>
              <th class="auto-width">
                Janela 4
              </th>
              <th class="auto-width">
                Janela 5
              </th>
              <th class="auto-width">
                Janela 6
              </th> -->
              <th class="auto-width">
                Editar
              </th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let item of programacao ; let i = index">
              <tr>
                <td>{{ item.Transportadora }}</td>
                <td>{{ item['Transport Type'] }}</td>
                <td>{{ item.Plate }}</td>
                <td>{{ item.trailerPlate }}</td>
                <td>{{ item.Endereco }}</td>
                <td *ngIf="item['Conexao'] === true" (click)="toggleInformationMode(i)"><i-feather name="zap"
                    class="blinking-icon"></i-feather></td>
                <td *ngIf="item['Conexao'] !== true" (click)="toggleInformationMode(i)"><i-feather name="zap-off"
                    class="vermelho-icon"></i-feather></td>
                <td>{{ item.rota }}</td>
                <!-- <td>{{ item.percurso }}</td> -->
                <td>
                  <i-feather *ngIf="item['statusPasso'] > 0" name="check-circle" style="color: rgb(132, 250, 96);"></i-feather>
                </td>
                <td>{{ item.viagem }}</td>
                <td [ngClass]="{
                  'R26': item['Local'] === 'R26',
                  'R27': item['Local'] === 'R27',
                  'R54': item['Local'] === 'R54',
                  'R16': item['Local'] === 'R16',
                  'R19': item['Local'] === 'R19',
                  'R56': item['Local'] === 'R56',
                  'E37': item['Local'] === 'E37',
                  'PRU': item['Local'] === 'PRU',
                  'E56': item['Local'] === 'E56',
                  'R4': item['Local'] === 'R4',
                  'P40': item['Local'] === 'P40',
                  'VAZIO': item['Local'] === undefined,
                  'CMP': item['ViagemCompleta'],
                  'CANCEL': item['viagemCancelada']
                }" (click)="salvarStatus(item)">
                  <h3 class="my-heading">{{ item['Local'] }}</h3>
                  <i-feather *ngIf="item['viagemCancelada']" name="x" style="color: rgb(255, 41, 41);"></i-feather>
                  <!-- <h4 class="my-subheading">{{ item['Janela 1'] | date: 'dd/MM/yyyy - HH:mm' }}</h4> -->
                </td>
                <td>{{ item.Janela | date : 'dd/MM/yyyy HH:mm': '+00:00'}}</td>
                <td>{{ item.observacao }}</td>


                <td class="icones">
                  <i-feather name="edit" (click)="editDialog(item)"></i-feather>
                  <i-feather name="check-square" (click)="completeItem(item)" class="button-spacing"></i-feather>
                  <i-feather name="x-square" (click)="cancelaItem(item)" class="button-spacing"></i-feather>
                  <i-feather name="trash-2" (click)="deleteItem(item.ID)" class="button-spacing"></i-feather>
                  <!-- <i-feather name="delete" (click)="verificaJanelasConcluidas()" class="button-spacing"></i-feather> -->
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
  <h3 class="modal-title">Ajuste de Programação</h3>
  <div class="modal-body">
    <form class="inputs">
      <table class="table2000">
        <tr>
          <td style="width: 100px;">
            <label class="modal-label">Transportadora</label>
          </td>
          <td style="width: 250px;">
            <select id="Transportadora" name="Transportadora" [(ngModel)]="item.Transportadora" class="modal-select">
              <option *ngFor="let nome of transportadora" [value]="nome">{{ nome }}</option>
            </select>
          </td>
          <td style="width: 100px;">
            <label class="modal-label">Placa</label>
          </td>
          <td style="width: 20px;">
            <input type="string" name="Plate" [(ngModel)]="item.Plate" class="modal-input1" (blur)="onFieldTouched()">
            <div *ngIf="campoTocado && (item.Plate == null || item.Plate == undefined || item.Plate == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td style="width: 100px;">
            <label class="modal-label">Placa Carreta</label>
          </td>
          <td style="width: 20px;">
            <input type="string" name="trailerPlate" [(ngModel)]="item.ID" class="modal-input1">
          </td>
        </tr>
      </table>
      <table class="table2000">
        <tr>
          <td style="width: 100px;">
            <label class="modal-label">Local</label>
          </td>
          <td style="width: 250px;">
            <select id="Local" name="Local" [(ngModel)]="item['Local']" class="modal-select1">
              <option *ngFor="let local of locais" [value]="local">{{ local }}</option>
            </select>
          </td>
          <td style="width: 100px;">
            <label class="modal-label">Viagem</label>
          </td>
          <td style="width: 20px;">
            <input type="string" id="viagem" name="viagem" [(ngModel)]="item.viagem" class="modal-input1">
          </td>
          <td style="width: 100px;">
            <label class="modal-label">Rota</label>
          </td>
          <td style="width: 20px;">
            <input type="string" id="rota" name="rota" [(ngModel)]="item.rota" class="modal-input1">
          </td>

        </tr>
        <tr>
          <td style="width: 100px;">
            <label class="modal-label">Peso</label>
          </td>
          <td style="width: 20px;">
            <input type="number" id='peso' name='peso' [(ngModel)]="item['Weight Loaded']" class="modal-input1"
              (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item['Weight Loaded'] == null || item['Weight Loaded'] == undefined || item['Weight Loaded'] == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td style="width: 100px;">
            <label class="modal-label">Distância</label>
          </td>
          <td style="width: 250px;">
            <input type="number" id='distance' name='distance' [(ngModel)]="item['Total Distance']" required
              class="modal-input1" (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item['Total Distance'] == null || item['Total Distance'] == undefined || item['Total Distance'] == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td style="width: 100px;">
            <label class="modal-label">Janela</label>
          </td>
          <td style="width: 250px;">
            <input *ngIf="item.ID" type="string" id="Janela" name="Janela" [(ngModel)]="item.Janela" required
              class="modal-input1" />
            <input *ngIf="!item.ID" type="datetime-local" id="Janela" name="Janela" [(ngModel)]="item.Janela" required
              class="modal-input1" />
          </td>
        </tr>
      </table>
      <div class="modal-div">
        <button class="modal-button" type="button" (click)="salvar2(item)">Save</button>
        <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>